import { render, staticRenderFns } from "./CeramicAging.vue?vue&type=template&id=ce7357e2&scoped=true"
import script from "./CeramicAging.vue?vue&type=script&lang=ts"
export * from "./CeramicAging.vue?vue&type=script&lang=ts"
import style0 from "./CeramicAging.vue?vue&type=style&index=0&id=ce7357e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7357e2",
  null
  
)

export default component.exports